import { IBit, IBitConditionKey, IGambit } from "../store/types";

const comparatorLabels: Record<IBitConditionKey, string> = {
  greaterThan: ">",
  greaterThanOrEqual: ">=",
  lessThan: "<",
  lessThanOrEqual: "<=",
  equal: "==",
  notEqual: "!=",
  always: "always",
  never: "never"
};

export function stringifyCondition(comparator: IGambit["condition"]) {
  const { left, key, right } = comparator;

  // right may be a number, if so, it is a percentage that can be stringified
  let parsedRight: string;
  if (typeof right === "number") parsedRight = `${Math.round(right * 100)}%`;
  else {
    parsedRight = right;
  }

  const comparatorLabel = comparatorLabels[key];
  if (key === "always" || key === "never" || comparatorLabel === undefined)
    return comparatorLabel || "?";
  return `${left} ${comparatorLabel} ${parsedRight}`;
}

export const replaceFinishDigits = (s: string): string =>
  s.replace(/(\d+)$/, " $1");

export const cleanName = (s: string): string =>
  s.replace("_", " ").replace(/(\d+)$/, " $1");

// FIXME: key: string is solely there for SelectionChoices. Remove it
export default function stringifyBit(bit: IBit | { key: string }) {
  if (!bit) return "?";
  // handle action and target bits
  if (!("left" in bit && "right" in bit)) return replaceFinishDigits(bit.key);
  return stringifyCondition(bit);
}
